import React, { Component, useEffect, useState } from 'react';
// import endpoint_code_cases from '../../data/2022-12/endpoint_code_cases__FG_pheno-r10_geno-r9__2022-12-16.json';
import endpoint_code_cases from '../../data/2023-05/endpoint_code_cases__FG_pheno-r11_geno-r10__2023-05-17.json';
import endpoint_info from '../../data/2023-05/endpoints_info__FG_pheno-r11_geno-r10__2023-05-17.json';
import network_hubs from './../../data/2023-05/network_hubs.json';
import finngen from '../..//img/finngen_logo.svg'
import Search from '../header/search'
import * as d3 from "d3";

function EndpointList (props) {

    const data = props.data
    const setData = props.setData
    const search = props.search
    const setSearch = props.setSearch
    const setView = props.setView
    const setNetwork = props.setNetwork
    const color = props.color
    const retrieve = props.retrieve
    const format = props.format
    const contentHeight = props.contentHeight
    const highlightQuery = props.highlightQuery
    const heatmap = props.heatmap
    const setHeatmap = props.setHeatmap
    const updateHeatmap = props.updateHeatmap

    console.log(endpoint_info)

    const [sort, setSort] = useState({parameter: 'n_cases_all', order: 1})
    const [filters, setFilters] = useState([])

    const u = 13.5

    function drawList (data, location) {
        // document.getElementById('e_rows').scrollTop = 0

        const maxCases = d3.max(data.map(el => el.n_cases_all))
        const rScale = d3.scaleLinear().domain([0, Math.sqrt(maxCases)]).range([0, 2.5*u])

        function sortEndpoints (list, parameter, order) {
            
            function compare (a, b) {
                var elA, elB;

                if (parameter === 'n_cases_female') {
                    elA = a['n_cases_female'] / a['n_cases_all'];
                    elB = b['n_cases_female'] / b['n_cases_all'];
                } else if (parameter === 'gwas_hits') {
                    elA = +a['gwas_hits'];
                    elB = +b['gwas_hits'];
                } else {
                    elA = a[parameter];
                    elB = b[parameter];
                }

                if (elA === undefined || elA === null) return 1
                else if (elB === undefined || elB === null) return -1
                if (elA < elB) return 1*order;
                else if (elA > elB) return -1*order;
                else return 0;
            }
            
            return list.sort(compare);
        }
        
        var endpoints = sortEndpoints(data, sort.parameter, sort.order)
        
        if (filters.length > 0) {
            if (filters.includes('core')) endpoints = endpoints.filter(el => el.core_endpoint === 'yes')
            if (filters.includes('meta_uk')) endpoints = endpoints.filter(el => el.uk_meta_analysed === 'MetaAnalyzed')
            if (filters.includes('meta_est')) endpoints = endpoints.filter(el => el.est_meta_analysed === 'MetaAnalyzed')
            //if (filters.includes('network')) endpoints = endpoints.filter(el => el.crossCheck === 'y')
            if (filters.includes('network')) endpoints = endpoints.filter(el => !isNaN(el.n_cases_all) && network_hubs.includes(el.code) )
            if (filters.includes('heatmap')) endpoints = endpoints.filter(el => endpoint_code_cases[el.code] !== undefined)
        }

        d3.select(location).selectAll('.e_row').data(endpoints).join(
            function(enter){
                const row = enter.append('div').attr('class', 'e_row')

                row.append('div')
                    .style('width', '10%')
                    .style('display', 'flex')
                    .style('justify-content', 'center')
                    .append('div')
                        .attr('class', 'e_row_number')
                        .style('background-color', d => d.core_endpoint === 'yes' ? color.purple: 'transparent')
                        .style('color', d => d.core_endpoint === 'yes' ? 'white': color.gray)
                        .html(d => d.gwas_hits === null ? 0 : d.gwas_hits)

                const first = row.append('div')
                    .attr('class', 'e_row_first')
                    .style('width', '45%')
                    .style('background-color', d=>heatmap.map(el=>el.code).includes(d.code) ? color.lightviolet : 'white')

                const name = first.append('div').attr('class', 'e_row_inner').style('width', '70%')
                name.append('p').attr('class', 'e_longname').html(d => highlightQuery(d.longname, search))
                name.append('p').attr('class', 'e_endpoint').html(d => highlightQuery(format.name(d.code), search))

                const meta = first.append('div').attr('class', 'e_row_inner tag_container').style('width', '30%')
                meta.append('div').attr('class', 'tag uk').html('UK').style('display', d => d.uk_meta_analysed === 'MetaAnalyzed' ? 'block' : 'none')
                meta.append('div').attr('class', 'tag est').html('EST').style('display', d => d.est_meta_analysed === 'MetaAnalyzed' ? 'block' : 'none')

                const second = row.append('div').attr('class', 'e_row_second').style('width', '35%')

                const svg = second.append('svg')
                    .attr('class', 'e_svg')
                    .attr('width', 6*u)
                    .attr('height', 6.5*u)
                
                svg.append('circle')
                    .attr('cx', 3*u).attr('cy', 3*u)
                    .attr('r', d => rScale(Math.sqrt(d.n_cases_all)))
                    .style('fill', color.violet)
                    .style('cursor', 'pointer')
                    .on('mouseenter', function() {d3.select(this.parentNode.parentNode).select('.e_count').style('color', color.violet)})
                    .on('mouseleave', function() {d3.select(this.parentNode.parentNode).select('.e_count').style('color', color.gray)})
                svg.append('rect')
                    .attr('class', 'e_rect')
                    .attr('x', 0).attr('y', 6*u)
                    .attr('height', 0.5*u).attr('width', 6*u)
                    .style('fill', color.pink)
                    .style('display', d => (d.n_cases_male === null || d.n_cases_female === null) ? 'none' : 'block')
                    .style('cursor', 'pointer')
                    .on('mouseenter', function() {d3.select(this.parentNode.parentNode).select('.e_females').style('color', color.violet)})
                    .on('mouseleave', function() {d3.select(this.parentNode.parentNode).select('.e_females').style('color', color.gray)})
                svg.append('rect')
                    .attr('class', 'e_ratio')
                    .attr('x', 0).attr('y', 6*u)
                    .attr('height', 0.5*u).attr('width', d => 6*u*d.n_cases_male/d.n_cases_all)
                    .style('fill', color.purple)
                    .style('cursor', 'pointer')
                    .on('mouseenter', function() {d3.select(this.parentNode.parentNode).select('.e_males').style('color', color.violet)})
                    .on('mouseleave', function() {d3.select(this.parentNode.parentNode).select('.e_males').style('color', color.gray)})

                const cases = second.append('div').attr('class', 'e_row_inner')
                cases.append('p').attr('class', 'e_row_info e_count').style('margin-bottom', '5px').html(d => 'Cases: <strong>'+ format.count(d.n_cases_all, d.code) + '</strong')
                cases.append('p').attr('class', 'e_row_info e_males').html(d => 'Males: '+ format.ratio(d.n_cases_male, d.n_cases_all))
                cases.append('p').attr('class', 'e_row_info e_females').html(d => 'Females: '+ format.ratio(d.n_cases_female, d.n_cases_all))

                const menu = row.append('div').attr('class', 'e_menu').style('width', '10%')
                menu.append('a').attr('class', 'e_row_info e_risteys').attr('target', '_blank').attr('href', d => "https://risteys.finngen.fi/endpoint/" + d.code).append('div').html('&#8594 Risteys')
                menu.append('a').attr('class', 'e_row_info e_pheweb').attr('target', '_blank').attr('href', d => "https://results.finngen.fi/pheno/" + d.code).append('div').html('&#8594 PheWeb')
                menu.append('a').attr('class', 'e_row_info e_network')
                    .style("display", d => network_hubs.includes(d.code) && !isNaN(d.n_cases_all) ? 'block' : 'none')
                    .append('div').html('&#8594 Network').on('click', (e,d) => {setNetwork(d.code); setView('network')})
                menu.append('a').attr('class', 'e_row_info e_heatmap').append('div')
                    .style('display', d => endpoint_code_cases[d.code] === undefined ? 'none' : 'block')
                    .html(d=>heatmap.map(el=>el.code).includes(d.code) ? '–\u2000 Heatmap' : '+\u2000 Heatmap')
                    .on('mouseenter', ()=>d3.select('#h_sub').style('top', '42px').style('opacity', 1))
                    .on('mouseleave', ()=>d3.select('#h_sub').style('top', '-300px').style('opacity', 0))
                    .on('click', (e,d) => {updateHeatmap(d.code, d.longname, d.n_cases_all); })
            },
            function(update){
                update.select('.e_row_first').style('background-color', d=>heatmap.map(el=>el.code).includes(d.code) ? color.lightviolet : 'white')
                
                update.select('.e_row_number')
                    .style('background-color', d=>d.core_endpoint === 'yes' ? color.purple: 'transparent')
                    .style('color', d=>d.core_endpoint === 'yes' ? 'white': color.gray)
                    .html(d => d.gwas_hits === null ? 0 : d.gwas_hits)
                
                update.select('.e_longname').html(d => highlightQuery(d.longname, search))
                update.select('.e_endpoint').html(d => highlightQuery(format.name(d.code), search))

                update.select('.uk').style('display', d => d.uk_meta_analysed === 'MetaAnalyzed' ? 'block' : 'none')
                update.select('.est').style('display', d => d.est_meta_analysed === 'MetaAnalyzed' ? 'block' : 'none')

                update.select('circle').attr('r', d => rScale(Math.sqrt(d.n_cases_all)))
                update.select('.e_rect').style('display', d => (d.n_cases_male === null || d.n_cases_female === null) ? 'none' : 'block')
                update.select('.e_ratio').attr('width', d => 6*u*d.n_cases_male/d.n_cases_all)

                update.select('.e_count').html(d => 'Cases: <strong>'+ format.count(d.n_cases_all, d.code) + '</strong')
                update.select('.e_males').html(d => 'Males: '+ format.ratio(d.n_cases_male, d.n_cases_all))
                update.select('.e_females').html(d => 'Females: '+ format.ratio(d.n_cases_female, d.n_cases_all))

                update.select('.e_risteys').attr('href', d => "https://risteys.finngen.fi/endpoint/" + d.code)
                update.select('.e_pheweb').attr('href', d => "https://results.finngen.fi/pheno/" + d.code)
                update.select('.e_network')
                    .style("display", d => network_hubs.includes(d.code) && !isNaN(d.n_cases_all) ? 'block' : 'none')
                    .select('div').on('click', (e,d) => {setNetwork(d.code); setView('network')})
                update.select('.e_heatmap').select('div')
                    .style('display', d => endpoint_code_cases[d.code] === undefined ? 'none' : 'block')
                    .html(d=>heatmap.map(el=>el.code).includes(d.code) ? '–\u2000 Heatmap' : '+\u2000 Heatmap')
                    .on('click', (e,d) => {updateHeatmap(d.code, d.longname, d.n_cases_all); })

            }
        )
    }

    useEffect(()=> {

        d3.select("#search_bar_2").on("keypress", e => {if (e.key === "Enter") document.getElementById("search_btn_2").click()});
        d3.select("#search_btn_2").on("click", () => {
            const newSearch = document.getElementById('search_bar_2').value
            document.getElementById("search_bar_1").value = "";
            document.getElementById("search_bar_2").value = "";
            setSearch(newSearch)
          });

        d3.select('#e_firstrow').selectAll('.firstrow_sort')
            .classed('sort', function(){return d3.select(this).attr('id').includes(sort.parameter)})
            .on('click', function(){
                const selected = d3.select(this)
                var newParameter = selected.attr('id').replace('firstrow_','')
                var newOrder
                
                if (newParameter === sort.parameter) newOrder = -sort.order 
                else if (newParameter === 'longname' || newParameter === 'code') newOrder = -1
                else newOrder = 1

                d3.selectAll('.sort').each(function(){d3.select(this).html(d3.select(this).html().replace(' ↓', '').replace(' ↑', ''))})

                newOrder === 1 ? selected.html(selected.html() + ' ↑') : selected.html(selected.html() + ' ↓')
                setSort({parameter: newParameter, order: newOrder})
            })

        d3.select('#e_firstrow').selectAll('.firstrow_filter')
            .classed('filter', function(){
                var check = false
                filters.forEach(el => {
                    if (d3.select(this).attr('id').includes(el)) check = true})
                return check
            })
            .on('click', function(){
                const newFilter = d3.select(this).attr('id').replace('firstrow_','')
                if (filters.includes(newFilter)) setFilters(filters.filter(el => el !== newFilter))
                else {
                    const newFilters = [...filters]
                    newFilters.push(newFilter)
                    setFilters(newFilters)
                }
            })

        if (data.endpoints !== undefined) {
            var all = []
            data.endpoints.forEach(endpoint => {
                const datum = endpoint_info.filter(el => el.code === endpoint)[0]
                datum && all.push(datum)
            })

            var matches = []
            var others = []
    
            if (search === undefined) drawList (all, '#e_all')
            else {
                all.forEach(el =>
                    {
                    if (el.code.toLowerCase().includes(search.replaceAll(' ',  '_')) || el.longname.toLowerCase().includes(search)) matches.push(el)
                    else others.push(el)
                    }
                )
                matches.length !== 0 && drawList (matches, '#e_matches')
                others.length !== 0 && drawList (others, '#e_others')                
            }
        }
    })

    return (
        <div id='endpoints'>
            {data.endpoints === undefined && (
                <div id="e_placeholder">
                    <div id="e_placeholder_inner">
                    <div id="p_logos">
                        <div id="p_finngen">
                            <img src={finngen} alt="Finngen logo" width="23" />
                        </div>
                        <div id="p_logo">
                            <h1 id="p_logo_name">The Endpoint Browser</h1>
                            <h1 id="p_logo_release">FinnGen Release 11</h1>
                        </div>
                    </div>    
                    </div>
                </div>
            )}
            {data.endpoints !== undefined && (
                <div id="e_content">
                    <div id="e_title">
                        <div className="title_inner"><h1>Endpoint list</h1></div>
                        <div className="title_inner"><h2>{data.code + ": " + data.name}</h2></div>
                    </div>
                    <div id="e_firstrow" >
                        <div className="firstrow_primary_container"> 
                            <h5 className="firstrow_title">Importance</h5>
                            <div className="firstrow_secondary_container" style={{display: 'flex'}}>
                                <h5 id="firstrow_gwas_hits" className='firstrow_sort'>GWAS hits</h5>
                                <h5 id="firstrow_core" className='firstrow_filter'>⫧ Core</h5>
                            </div>
                        </div>
                        <div className="firstrow_primary_container">
                            <h5 className="firstrow_title">Endpoint</h5>
                            <div className="firstrow_secondary_container" style={{display: 'flex'}}>
                                <h5 id="firstrow_longname" className='firstrow_sort'>Name</h5>
                                <h5 id="firstrow_code" className='firstrow_sort'>Code</h5>
                            </div>
                        </div>
                        <div className="firstrow_primary_container">
                            <h5 className="firstrow_title">Meta analysis</h5>
                            <div className="firstrow_secondary_container" style={{display: 'flex'}}>
                                <h5 id="firstrow_meta_est" className='firstrow_filter'>⫧ Estonia</h5>
                                <h5 id="firstrow_meta_uk" className='firstrow_filter'>⫧ UK</h5>
                            </div>
                        </div>
                        <div className="firstrow_primary_container">
                            <h5 className="firstrow_title">Cases</h5>
                            <div className="firstrow_secondary_container" style={{display: 'flex'}}>
                                <h5 id="firstrow_n_cases_all" className='firstrow_sort'>Number ↑</h5>
                                <h5 id="firstrow_n_cases_female" className='firstrow_sort'>Sex ratio</h5>
                            </div>
                        </div>
                        <div className="firstrow_primary_container">
                            <h5 className="firstrow_title">Links</h5>
                            <div className="firstrow_secondary_container" style={{display: 'flex'}}>
                                <h5 id="firstrow_network" className='firstrow_filter'>⫧ Network</h5>
                                <h5 id="firstrow_heatmap" className='firstrow_filter'>⫧ Heatmap</h5>
                            </div>
                        </div>
                    </div>
                    <div id="e_rows" style={{height: contentHeight-107+'px'}}>
                        <div id="e_all" style={{display: search === undefined ? 'block' : 'none'}}></div>
                        <div id="e_matches" style={{display: search === undefined ? 'none' : 'block'}}>
                            <div className="e_rows_title"><h5>Endpoints containing<br/>the search query: {search && search.toUpperCase()}</h5></div>
                        </div>
                        <div id="e_others" style={{display: search === undefined ? 'none' : 'block'}}>
                            <div className="e_rows_title"><h5>All the other endpoints<br/>of the ICD block</h5></div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default EndpointList;